module.exports = {
    SAVENEW     : "saveNew",
    SAVEDRAFT   : "saveDraft",
    SAVEPRINT   : "savePrint",
    SAVECLOSE   : "saveClose",
    DELETE      : "delete",
};